import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'
import { dropdownsService } from 'onboarding/services/dropdownsService'

import { PARTNERSHIP_DETAILS_NA_DROPDOWN_KEY } from '../constants'

interface IUsePartnerShipNADistributors {
  country: string
}

export const usePartnerShipNADistributors = ({ country }: IUsePartnerShipNADistributors) => {
  const appId = useSelector(selectAppId)
  const crud = useMemo(() => {
    return dropdownsService.getCrud({
      appId,
      dropdown: PARTNERSHIP_DETAILS_NA_DROPDOWN_KEY,
      relation: country,
      cacheKey: 'partnerShipNADistributors',
    })
  }, [appId, country])

  return { crud }
}
